module.exports = __webpack_public_path__ + "img/1518443206.1b031706.jpg";